import React, { PropsWithChildren } from "react";

const ReportLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
        {children}
    
    </>
  );
};

export default ReportLayout;
